import React, { useMemo } from "react";

export const HighlightText = ({ fullText, textToHighlight, bold }) => {
  const textRegex = useMemo(() => {
    return new RegExp(`(${textToHighlight})`, "i");
  }, [fullText, textToHighlight]);
  const textParts = textToHighlight ? fullText.split(textRegex) : fullText; // if their is any text to highlight do the split, otherwise just return the entire text. If we do the split using regex on an empty string it will split everything up and we will be creating empty spans between each letter.
  //   console.log(textParts);

  return typeof textParts === "string"
    ? textParts
    : textParts.map((textPart, index) => {
        // console.log("textpart", textPart.toLowerCase());
        // console.log("text to highlight", textToHighlight.toLowerCase());
        // console.log(
        //   "are equal",
        //   textPart.toLowerCase() === textToHighlight.toLowerCase()
        // );
        return textPart.toLowerCase() === textToHighlight.toLowerCase() ? (
          <span
            key={index + textPart}
            style={{
              backgroundColor: "yellow",
              //   color: "black",
              //   padding: ".1rem",
              fontWeight: bold ? "600" : "",
            }}
          >
            {textPart}
          </span>
        ) : (
          textPart
        );
      });
};
